let searchApiBaseUrl = '';
try {
  const search_bar_vars = (window as any).search_bar_vars || "";
  if (typeof (search_bar_vars) != "undefined" && search_bar_vars !== '') {
      const searchbarVars = JSON.parse(atob(search_bar_vars)); 
      searchApiBaseUrl = searchbarVars.searchApiBaseUrl || '';
  }
} catch(e) {
    console.log('Error setting search base URL');
}


export const config = {
  searchBaseUrl:  searchApiBaseUrl
};
